import styles from './DashboardSectionSkeleton.module.css';

export function DashboardKpiGridSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className={styles.kpiGrid} aria-hidden>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.kpiBlock} />
      ))}
    </div>
  );
}

export function DashboardChartSkeleton() {
  return <div className={styles.chartBlock} aria-hidden />;
}

export function DashboardMailListSkeleton({ rows = 2 }: { rows?: number }) {
  return (
    <div className={styles.mailSkeletonList} aria-hidden>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={styles.mailRowBlock} />
      ))}
    </div>
  );
}
